export default __webpack_public_path__ + "static/media/dtsu5168_direct.2ba5dfa7.png";